import CoreContactsGrid from './CoreContactsGrid';

export { type CoreContactsGridProps } from './CoreContactsGrid';
export default CoreContactsGrid;
